import z from 'zod';

export const ExploreFilterSchema = z.object({
    title: z
        .string()
        .min(10, { message: 'عنوان درخواست باید حداقل ۱۰ کاراکتر باشد' })
        .max(150, { message: 'عنوان درخواست نباید بیشتر از ۱۵۰ کاراکتر باشد' })
});

export type ExploreFilterFormValues = z.infer<typeof ExploreFilterSchema>;

